 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, isEnabled, isNumber } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const ProdSched = props => {

    const panelsdef = [];
    const formid = getformid("ProdSched", props.location.search);
    const controller = getcontroller("ProdSched", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const menuinfo = useSelector(state => state.form.menuinfo);

    const fnc = useRef();

    //データ
    const entrydataRef = useRef(null);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const ComFunc = React.forwardRef(ComFunction);


    const actionurl = {
        "update": "ProdSched/Update",
        "getlist": "ProdSched/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]

    // 動作抑止
    // type=0: 加工指示      -> CONDITION / UPDATE
    // type=1: 加工指示SKU   -> CONDITION のみ
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "1", action: "INSERT" },
        { type: "1", action: "UPDATE" }
    ];

    function listlockCell(params, edit, status) {
        if (!edit) return edit;

        // サーバーから返す prod_order_approved=1 は
        // 「承認済みの製商品発注がこの加工指示に紐づいている」ことを表します。
        // MasterLayout の既存 lockcell を使うことで、行単位で Update を readonly 化します。
        if (status === "UPDATE" && params.data && String(params.data.prod_order_approved || "") === "1") {
            return false;
        }

        return edit;
    }


    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                suppressaction={suppressaction}
                lockcell={listlockCell}
                entrydataRef={entrydataRef}
                usecondition={true}
           >
            </MasterBase>
        </div>
    );
};

